import { COLLECTIONS, MUTATE_OPERATIONS_SENT } from "constants/action-types";
import { formatMessage } from "lib/globalize-util";
import { snackbarAdd } from "actions/snackbars";
import { Observable } from "rxjs";
import { getAndIncrementRequestId, mapToOperation } from "./helpers";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import { List } from "immutable";
import * as SentryUtil from "lib/sentry-util";
import { AssortmentEvents, AssortmentTransactions } from "constants/sentry-metrics";

const mapOperationToThisEndpoint = (operation) => {
    let operationName: string;
    if (operation.insert) {
        operationName = "insert";
    } else if (operation.remove) {
        operationName = "remove";
    } else if (operation.move) {
        operationName = "move";
    } else if (operation.set) {
        operationName = "set";
    }
    return {
        [`${operationName}_item_display_preference`]: operation[operationName],
    };
};

// sync display preference items to the server (add, update, delete, move)
// triggered after mutation epics have run
export const syncItemDisplayPreferencesEpic = (action$, store) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.SYNC.START)
        // Dont proceed if there is something sending or there is nothing to send
        .filter(({ payload: { objectId } }) => {
            const { mutate } = store.getState();
            const { sentMutations, uncommittedMutations } = mutate;
            const sentMutation = sentMutations.get(objectId);
            const uncommittedMutation = uncommittedMutations.get(objectId) || List();

            return !sentMutation && !!uncommittedMutation.size;
        })
        .map(({ payload: { objectId, syncData } }: { payload: { objectId: string; syncData: any } }) => {
            const { collection, mutate } = store.getState();

            const { committedHEADs, uncommittedMutations } = mutate;
            const { sessionId, merchantId } = collection;

            const committedHEAD = committedHEADs.get(objectId);

            const operations = [];
            uncommittedMutations.get(objectId).forEach((mutation) => {
                mutation.operations.forEach((operation) => {
                    operations.push(mapOperationToThisEndpoint(mapToOperation(operation)));
                });
            });
            const requestId = getAndIncrementRequestId(objectId);
            const revision = parseInt(committedHEAD.revision, 10) + 1;
            const command = {
                operations,
                revision,
                req_id: requestId,
            };

            store.dispatch({
                type: MUTATE_OPERATIONS_SENT,
                payload: {
                    requestId,
                    objectId,
                    revision,
                    objectType: committedHEAD.object_type,
                },
            });

            return { command, sessionId, requestId, collectionId: committedHEAD.document_id, merchantId, syncData };
        })
        // Make it a queue, wait for response before continuing
        .concatMap(({ command, collectionId, requestId, sessionId, merchantId, syncData }) => {
            const { isMerchantView } = syncData || {};
            const url = `/v1/collections/${collectionId}/${
                isMerchantView ? "merchant_display_preferences" : "display_preferences"
            }/mutate?sid=${sessionId}&req_id=${requestId}`;
            return (
                ajax({
                    body: { ...command, merchant_id: merchantId },
                    method: "POST",
                    url: siteConfig.goAPI + url,
                })
                    .map(() => ({
                        payload: { collectionId },
                        type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.SYNC.COMPLETED,
                    }))
                    // .concat(() => (snackbarAdd({ message: "View updated successfully!" })))
                    .catch((error) => {
                        // const actions = [];

                        // if (error.status === 409) {
                        //     return Observable.of({
                        //         type: COLLECTIONS.COLLECTION.ITEMS.SYNC.CONFLICT,
                        //         meta: {
                        //             collectionId,
                        //             objectId,
                        //         },
                        //         payload: error,
                        //         error: true,
                        //     });
                        // } else if (error.status === 404) {
                        //     // attempting to modify a deleted collection
                        //     actions.push(Observable.of(push(`/assortments`)));
                        //     actions.push(
                        //         Observable.of(snackbarAdd({ message: formatMessage("This assortment is no longer available") })),
                        //     );
                        // } else {
                        //     actions.push(Observable.of({
                        //         type: COLLECTIONS.COLLECTION.ITEMS.SYNC.ERROR,
                        //         payload: error,
                        //     }));
                        // }

                        return Observable.merge(
                            // ...actions,
                            // Observable.of({
                            //     error: true,
                            //     payload: error,
                            //     type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.IITEMDISPLAYPREFERENCE.ADD.COMPLETED,
                            // }),
                            Observable.of(
                                snackbarAdd({
                                    message: formatMessage("There was an error saving the view. Please try again."),
                                }),
                            ),
                        );
                    })
            );
        });

export const stopMeasuringColumnOperationsPerformance = (action$) =>
    action$.ofType(COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.CURRENT_VIEW.CHANGE).flatMap(() => {
        process.nextTick(() => {
            SentryUtil.finishSpan(AssortmentTransactions.AddColumn, AssortmentEvents.AddColumn);
            SentryUtil.finishTransaction(AssortmentTransactions.AddColumn);

            SentryUtil.finishSpan(AssortmentTransactions.PinColumn, AssortmentEvents.PinColumn);
            SentryUtil.finishTransaction(AssortmentTransactions.PinColumn);

            SentryUtil.finishSpan(AssortmentTransactions.MoveColumn, AssortmentEvents.MoveColumn);
            SentryUtil.finishTransaction(AssortmentTransactions.MoveColumn);

            SentryUtil.finishSpan(AssortmentTransactions.ResizeColumn, AssortmentEvents.ResizeColumn);
            SentryUtil.finishTransaction(AssortmentTransactions.ResizeColumn);
        });
        return [];
    });
